module.exports = __webpack_public_path__ + "img/img2.ff0f2513.ff0f2513.jpg";